import { Component, ContentChild, EventEmitter, Input, NgIterable, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
//import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { onConfirmDialog } from '../../../../../core/helpers/helpers.function';
import { IAvailableTypes, IConstantItem } from '../../../../../core/models/available-types.interface';
import { ICountry } from '../../../../../core/models/country.interface';
import { PageParams } from '../../../../../core/models/page-params.model';
import { ConstantService } from '../../../../../core/services/constant.service';
import { NotificationService } from '../../../../../core/services/notification.service';
import { UserService } from '../../../../../core/services/user.service';
import { ConfirmPopupDialog } from '../../../../../shared/popups/confirm-popup/confirm-popup.component';
import { ISPItemSizeRestriction, IStatus } from '../../../models/shipment-price.interface';

@Component({
    selector: 'eci-table-size-restrictions',
    templateUrl: './table-size-restrictions.component.html',
    styleUrls: [ './table-size-restrictions.component.scss' ]
})

export class TableSizeRestrictionsComponent implements OnInit {

    @Input() dataSource: MatTableDataSource<ISPItemSizeRestriction>;
    @Input() displayedColumns;
    @Input() availableCountries;
    @Input() shipmentPriceItemId: number;
    @Input() theCountriesList: ICountry[];
    @Input() pageParams: PageParams = new PageParams();
    @Input() weightUnits: IConstantItem[];
    @Input() dimensionsUnits: IConstantItem[];
    @Input() volumeUnits: IConstantItem[];
    quantityUnits: IConstantItem[] | undefined | null;

    @Output() pageChange: EventEmitter<PageParams> = new EventEmitter<PageParams>(null);
    @Output() onNavigate: EventEmitter<any> = new EventEmitter<any>(null);
    @Output() sortRows: EventEmitter<Sort> = new EventEmitter<Sort>(null);
    // Todo: Should be generic type
    @Output() public onEdit: EventEmitter<any> = new EventEmitter<any>(null);
    @Output() public onCancel: EventEmitter<any> = new EventEmitter<any>(null);
    @Output() public onSave: EventEmitter<any> = new EventEmitter<any>(null);
    @Output() public onDelete: EventEmitter<any> = new EventEmitter<any>(null);
    @Output() public onNewRow: EventEmitter<any> = new EventEmitter<any>(null);

    @ViewChild(MatSort) sort: MatSort;
    @ContentChild(TemplateRef) controlTemplate: TemplateRef<any>;

    public isEditMode = false;
    public addNewRowDataBtn: boolean = false;
    public form: FormGroup;
    public availableTypes: IAvailableTypes;
    public countriesList: ICountry[] = [];

    constructor(
        public userSvc: UserService,
        private dialog: MatDialog,
        // private constSvc: ConstantService,
        // private notify: NotificationService,
    ) {}

    ngOnInit(): void {
        this.countriesList = this.theCountriesList;
        this.form = this.initializeForm();
    }

    private initializeForm(data?: ISPItemSizeRestriction): FormGroup {
        return new FormGroup({
            // parentId: new FormControl(''),
            packingType: new FormControl({disabled: false, value: data?.packingType || 'parcel'},
                [ Validators.required, Validators.minLength(1), Validators.maxLength(100) ]),
            countryCode: new FormControl({disabled: false, value: data?.countryCode || 'all'},
                [ Validators.required, Validators.minLength(2) ]),
            maxLength: new FormControl({disabled: false, value: data?.maxLength || '10'},
                [ Validators.required, Validators.min(0.01) ]),
            maxWidth: new FormControl({disabled: false, value: data?.maxWidth || '10'},
                [ Validators.required, Validators.min(0.01) ]),
            maxHeight: new FormControl({disabled: false, value: data?.maxHeight || '10'},
                [ Validators.required, Validators.min(0.01) ]),
            dimensionsUnitsOfMeasure: new FormControl({disabled: false, value: data?.dimensionsUnitsOfMeasure || 'cm'},
                [ Validators.required ]),
            maxWeight: new FormControl({disabled: false, value: data?.maxWeight || '10'},
                [ Validators.required, Validators.min(0.01) ]),
            weightUnitsOfMeasure: new FormControl({disabled: false, value: data?.weightUnitsOfMeasure || 'kg'},
                [ Validators.required ]),
            maxVolume: new FormControl({disabled: false, value: data?.maxVolume || '10'},
                [ Validators.required, Validators.min(0.01) ]),
            volumeUnitsOfMeasure: new FormControl({disabled: false, value: data?.volumeUnitsOfMeasure || 'liters'},
                [ Validators.required ]),
            maxQuantity: new FormControl({disabled: false, value: data?.maxQuantity || '20'},
                [ Validators.required, Validators.min(0.01) ]),
            shipmentPriceItemId: new FormControl({disabled: false, value: data?.shipmentPriceItemId || this?.shipmentPriceItemId},
                [ Validators.required ]),
            searchCountry: new FormControl(''),
        });
    }

    public pageChanged(e): void {
        this.pageChange.emit(e);
    }

    public sortData(e: Sort): void {
        this.sortRows.emit(e);
    }

    public navigateTo(row): void {
        this.onNavigate.emit(row);
    }

    public get isAdmin(): boolean {
        return this.userSvc.isAdmin;
    }

    public convertToPrice(value: any): any {
        return parseFloat(value || 0)
            .toFixed(2);
    }

    public delete(event, id: number, index: number): void {
        event.stopPropagation();
        const onConfirm = () => {
            this.onDelete.emit({ id, index });
            this.isEditMode = false;
            this.addNewRowDataBtn = false;
        };
        const dialogRef = this.dialog.open(ConfirmPopupDialog);
        onConfirmDialog(dialogRef, onConfirm, 'entity');
    }

    public save(event, element, index): void {
        event.stopPropagation();
        if (this.form.invalid) {
            return;
        }
        this.onSave.emit({
            form: this.form.value, element, onSuccess: () => {
                this.isEditMode = false;
                this.addNewRowDataBtn = false;
            }, index
        });
    }

    public close(event, element, index): void {
        event.stopPropagation();
        const onConfirm = () => {
            if (!element.id) {
                this.removeData(index);
            }
            this.isEditMode = false;
            this.addNewRowDataBtn = false;
        };
        const dialogRef = this.dialog.open(ConfirmPopupDialog);
        dialogRef.componentInstance.message = `Are you sure you want to cancel Edit action.`;
        dialogRef.componentInstance.rightBtnText = 'Yes';
        dialogRef.componentInstance.leftBtnText = 'No';
        dialogRef.afterClosed().subscribe(value => {
            if (!value) {
                return;
            }
            onConfirm();
        });
    }

    public edit(event, element, index): void {
        this.form = this.initializeForm();
        this.form.patchValue({
            // parentId: element.parentId,
            packingType: element.packingType,
            countryCode: element.countryCode,
            maxWidth: element.maxWidth,
            maxHeight: element.maxHeight,
            maxLength: element.maxLength,
            dimensionsUnitsOfMeasure: element.dimensionsUnitsOfMeasure,
            maxWeight: element.maxWeight,
            weightUnitsOfMeasure: element.weightUnitsOfMeasure,
            maxVolume: element.maxVolume,
            volumeUnitsOfMeasure: element.volumeUnitsOfMeasure,
            maxQuantity: element.maxQuantity,
        });
        this.isEditMode = element.id;
        this.addNewRowDataBtn = true;
    }

    public addNewRow(): void {
        this.addNewRowDataBtn = true;
        const newData: ISPItemSizeRestriction = {
            // parentId: '',
            packingType: 'Parcel',
            countryCode: 'ALL',
            maxWidth: 10,
            maxHeight: 10,
            maxLength: 10,
            dimensionsUnitsOfMeasure: 1,
            maxWeight: 10,
            weightUnitsOfMeasure: 1,
            maxVolume: 10,
            volumeUnitsOfMeasure: 1,
            maxQuantity: 10,
            shipmentPriceItemId: this.shipmentPriceItemId || this.shipmentPriceItemId,
        };
        this.isEditMode = undefined;
        this.form = this.initializeForm(newData);
        this.onNewRow.emit(newData);
    }

    getCorrectCountry(countryCode: any) {
        const selectedCountry = this.theCountriesList?.find((country) => country.code === countryCode);
        return (selectedCountry ? `${selectedCountry.name}(${selectedCountry.code})` : 'ALL');
    }

    private removeData(index: number) {
        this.onCancel.emit(index);
    }
}
